import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { NavbarDesktop } from './desktop';
import { NavbarMobile } from './mobile';
import { Menu, Web } from 'data';

type Props = {
	menu: Menu[];
	web: Web;
	title: string;
};

export const Navbar = ({ menu, title, web }: Props) => {
	const [showMobile, setShowMobile] = useState(false);

	return (
		<nav className="bg-white dark:bg-gray-800 shadow flex-1 ">
			<div className="w-full mx-auto px-8">
				<div className="flex items-center justify-between h-16">
					<NavbarDesktop menu={menu} web={web} title={title} />
					<div className="-mr-2 flex md:hidden">
						<button
							className="text-gray-800 dark:text-white inline-flex items-center justify-center p-2 rounded-md focus:outline-none"
							aria-label="Menú"
							onClick={() => setShowMobile(!showMobile)}>
							<FontAwesomeIcon icon={showMobile ? faXmark : faBars} className="w-5 h-5" />
						</button>
					</div>
				</div>
			</div>
			<NavbarMobile menu={menu} web={web} showMenu={showMobile} />
		</nav>
	);
};

export default Navbar;
